import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

export interface VideoTimeChange {
  type: 'frame-change' | 'time-set';
  amount: number;
}

@Injectable({
  providedIn: 'root',
})
export class VideoTimeService {
  private _updates: Subject<VideoTimeChange> = new BehaviorSubject<VideoTimeChange>(undefined);
  public readonly onTimeChange: Observable<VideoTimeChange> = this._updates.asObservable();

  public changeFrame(time: number) {
    this._updates.next({ type: 'frame-change', amount: time });
  }
  public setTime(time: number) {
    this._updates.next({ type: 'time-set', amount: time });
  }
}
